import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store';
import { initializeTracker } from '../../../monitoring/x-ray-tracker';

const XRayTrackerContainer: React.FC = () => {

  // eslint-disable-next-line no-shadow
  const permissions = useSelector(({ permissions }: AppState) => permissions);

  // eslint-disable-next-line no-shadow
  const { user } = useSelector(({ user }: AppState) => user);
  if (user.id && permissions.allowed_drugstores.length) {
    
    initializeTracker(user, permissions);
    
  }
  
  return <></>;
};
  
export default XRayTrackerContainer;